import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor, NgClass } from '@angular/common';

const animImage =
  trigger('moveImage', [
    state('0', style({
      transform: 'translateY(0)'
    })),
    state('1', style({
      transform: 'translateY(-{{ blockHeight }}px)'
    }), {params: {blockHeight: 0}}),
    state('2', style({
      transform: 'translateY(calc(2 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('3', style({
      transform: 'translateY(calc(3 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('4', style({
      transform: 'translateY(calc(4 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('5', style({
      transform: 'translateY(calc(5 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('6', style({
      transform: 'translateY(calc(6 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('7', style({
      transform: 'translateY(calc(7 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('8', style({
      transform: 'translateY(calc(8 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('9', style({
      transform: 'translateY(calc(9 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    state('10', style({
      transform: 'translateY(calc(10 * -{{ blockHeight }}px))'
    }), {params: {blockHeight: 0}}),
    transition('* => *', animate('.3s ease-in-out'))
]);

const animText = trigger(
  'fadeText', [
    transition(':enter', [
      style({height: 0, opacity: 0}),
      animate('250ms ease-in-out', style({ height: '*', opacity: 1}))
    ]),
    transition(':leave', [
      style({ height: '*', opacity: 1}),
      animate('250ms ease-in-out', style({height: 0, opacity: 0}))
    ])
  ]
)


@Component({
    selector: 'app-carousel-features',
    templateUrl: './carousel-features.component.html',
    styleUrls: ['./carousel-features.component.scss'],
    animations: [animImage, animText],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, NgClass, TranslateModule]
})
export class CarouselFeaturesComponent implements OnInit, AfterViewInit {

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(window.innerWidth <= 860 ) {
      if(!this.mobileMode) {
        this.mobileMode = !this.mobileMode;
      }
    } else {
      if(this.mobileMode) {
        this.mobileMode = !this.mobileMode;
      }
    }
  }

  @Input() data : Array<any>;
  @Input() type: string;
  @Input() title: string;
  @Input() subTitle: string;

  @ViewChild('imagesList') imageList: ElementRef;
  @ViewChild('titleGroup') titleGroup: ElementRef;

  height = 0;
  state = 0;
  mobileMode: Boolean;

  ngOnInit() {
    window.innerWidth <= 860 ? this.mobileMode = true : this.mobileMode = false;

  }
  ngAfterViewInit(): void {
    if(this.type === 'videos') {
      const videoItems = document.getElementsByClassName('carouselVideoItem');
      const actual = <HTMLVideoElement> videoItems.item(this.state);
      actual.muted = true;
      actual.play()
    }
  }

  playVideo(element, item) {
    const video : HTMLVideoElement = element.target;
    this.data.find(el => el.selected).selected = false;
    item.selected = true;

    const videoItems = document.getElementsByClassName('carouselVideoItem');
    for (let i = 0; i < videoItems.length; i++) {
        const element = <HTMLVideoElement> videoItems.item(i);
        element.pause();
        element.muted = true;
      }

    video.muted = true;
    video.play();
  }

  moveImage(item): void {
    // Set the selected flag
    const old = this.data.find(el => el.selected);
    old ? old.selected = false : '';
    item.selected = true;
    this.state = this.data.findIndex(el => el === item);

    // move image
    const dataCount = this.data.length;
    const imageListDivHeight = this.imageList.nativeElement.offsetHeight

    // Update the value for the animations
    this.height = imageListDivHeight / dataCount;

    // Hide the title if State != 0
    if(this.state == 0) {
      this.titleGroup.nativeElement.classList.remove('hide');
    } else {
      if(!this.titleGroup.nativeElement.classList.contains('hide')) {
        this.titleGroup.nativeElement.classList.add('hide');
      }
    }

    // Video Playing on click
    if(this.type === 'videos') {
      // carouselVideoItem
      const videoItems = document.getElementsByClassName('carouselVideoItem');
      const actual = <HTMLVideoElement> videoItems.item(this.state);

      for (let i = 0; i < videoItems.length; i++) {
        const element = <HTMLVideoElement> videoItems.item(i);
        element.pause();
        element.muted = true;

      }

      actual.currentTime = 0;
      actual.play();
    }
  }

}
